// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_o5-0";